import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../../helpers';
import { UPDATE_PASSWORD } from '../index';

export const updatePassword = async (variables, token) => {
    try {

        let { updatePassword } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_PASSWORD
        });

        return updatePassword;

    } catch({message}) { throw new Error(message); }
};
